<template>
  <v-card>
    <v-card-title class="justify-center">
      <h3 role="heading" aria-level="2" class="text-h2 pt-1 text-center">
        {{ $t('L_edelivery') }}
      </h3>
    </v-card-title>
    <v-divider class="under-title-divider" />
    <v-card-text class="text-content frame-parent mb-4">
      <v-card class="overflow-y-auto">
        <v-card-text
          id="scroll-target"
          v-scroll:#scroll-target="onScroll"
          column
          align-center
          justify-center
          style="max-height: 400px"
        >
          <div class="my-2" v-html="$t('L_crc_disclaimer_title')" />
          <div v-html="disclaimerBody" />
        </v-card-text>
      </v-card>
      <v-row justify="center">
        <v-col cols="11" px-3 class="text-center">
          <h4 class="mt-3 text-h4 font-weight-regular">
            {{ $t('L_if_you_decline') }}
          </h4>
        </v-col>
      </v-row>
      <v-row class="pt-4 text-center font-weight-medium">
        <v-col cols="12" class="mt-0 mb-0 pb-0 pt-0">
          {{ selectedPackage.addrLine1 }}
        </v-col>
        <v-col cols="12" v-if="selectedPackage.addrLine2" class="mt-0 mb-0 pb-0 pt-0">
          {{ selectedPackage.addrLine2 }}
        </v-col>
        <v-col cols="12" class="mt-0 mb-0 pb-0 pt-0">
          {{ selectedPackage.addrCity }}, {{ selectedPackage.addrState }}
          {{ selectedPackage.addrZip }}
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6" md="6" px-3 class="text-center align-addr-disclaimer">
          <h4
            class="mt-3 text-h4 text-left font-weight-regular"
            v-html="$t('L_you_can_update_this_address')"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pb-4">
      <v-col cols="12" class="text-center">
        <OnexButton
          class="agree-button"
          color="primary"
          @click="optIn"
          size="large"
          :text="$t('L_i_agree')"
        />
        <br />
        <h4
          class="text-center cursor-pointer mt-4 documents-link-font"
          @click="decline"
          v-html="$t('L_no_please_my_documents')"
        />
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useChildRiderStore } from '../../store/childrider.store';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'CRCStepD',
  components: {
    OnexButton,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data: () => ({
    offsetTop: 0,
  }),
  computed: {
    ...mapState(useChildRiderStore, {
      selectedPackage: 'NPPackage',
      isUSPolicy: 'isUSPolicy',
      isCanadaPolicy: 'isCanadaPolicy',
      isNYPolicy: 'isNYPolicy',
    }),
    disclaimerBody() {
      let body = 'L_crc_disclaimer_body_us_ny';
      if (this.isUSPolicy) {
        body = 'L_crc_disclaimer_body_us';
      }
      if (this.isCanadaPolicy) {
        body = 'L_crc_disclaimer_body_ca';
      }
      return this.$t(body, { phone: window.appConfig.techSupportPhone });
    },
  },
  methods: {
    ...mapActions(useChildRiderStore, {
      next: 'crcNext',
      pullAgreement: 'pullAgreement',
      setOptIn: 'setNPEDeliveryOptIn',
    }),
    onScroll(e: Event) {
      const target = e.target as HTMLElement | null;
      this.offsetTop = target ? target.scrollTop : 0;
    },
    optIn() {
      this.setOptIn('Y');
      this.next();
    },
    decline() {
      this.setOptIn('N');
      this.next();
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style>
.align-addr-disclaimer {
  max-width: 100%;
  flex-basis: 100%;
  display: flex;
  justify-content: center;
}
.documents-link-font {
  color: #02579e;
  font-weight: bolder;
}
.agree-button {
  min-width: 50%;
}
</style>
